'use strict';

/**
 * Возвращает текущую ориентацию экрана.
 *
 * @returns {('landscape' | 'portrait')}
 */
module.exports.getOrient = function () {
    return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
};

/**
 * Возвращает текущую платформу.
 *
 * @returns {('ios' | 'android' | 'wp' | 'other')}
 */
module.exports.getActivePlatform = function (platformList) {
    return Object.keys(platformList).filter(function (key) {
        return platformList[key];
    })[0];
};

/**
 * Проверяет устройство на наличие ретина экрана.
 *
 * @returns {boolean}
 */
module.exports.supportRetina = function () {
    var devicePixelRatio = 1;
    if ('deviceXDPI' in screen && 'logicalXDPI' in screen) {
        devicePixelRatio = screen.deviceXDPI / screen.logicalXDPI;
    } else if ('devicePixelRatio' in window) {
        devicePixelRatio = window.devicePixelRatio;
    }
    return devicePixelRatio >= 1.3;
};

/**
 * Проверяет поддерживает ли браузер svg.
 *
 * @returns {boolean}
 */
module.exports.supportSvg = function () {
    return 'createElementNS' in document &&
        document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect !== undefined;
};

/**
 * Проверяет поддерживает ли браузер inline svg.
 *
 * @returns {boolean}
 */
module.exports.supportInlineSvg = function () {
    var element = document.createElement('div');
    element.innerHTML = '<svg />';
    return element.firstChild &&
        element.firstChild.namespaceURI === 'http://www.w3.org/2000/svg';
};

/**
 * Проверяет поддерживает ли браузер свойство object-fit.
 *
 * @returns {boolean}
 */
module.exports.supportObjectFit = function () {
    return ['objectFit', 'OObjectFit'].some(function (key) {
        return document.documentElement.style[key] !== undefined;
    });
};
